module.exports = __webpack_public_path__ + "static/media/glass-cheers.33dc9d52.svg";